import { gql } from '@apollo/client';
import type { UnloadingOrderDetailInfoType } from './getUnloadingOrderDetailsByWaypointId';

// 干线卸车明细 drawer 分页列表（读 tms_loading_order_detail 已卸子集，content 形状与支线入库一致）
export const GET_UNLOADED_ORDER_DETAILS = gql`
    query GetUnloadedOrderDetails(
        $taskWaypointId: Long!
        $pageRequest: PageRequestTypeInput
        $trackingNumber: String
        $loadingWaypointId: Long
        $overallStatus: String
    ) {
        getUnloadedOrderDetails(
            taskWaypointId: $taskWaypointId
            pageRequest: $pageRequest
            trackingNumber: $trackingNumber
            loadingWaypointId: $loadingWaypointId
            overallStatus: $overallStatus
        ) {
            content {
                id
                trackingNumber
                overallStatus
                sortingCode
                bagNumber
                bagTaskNumber
                loadingWaypointSortingCode
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface GetUnloadedOrderDetailsResponse {
    getUnloadedOrderDetails: {
        content: UnloadingOrderDetailInfoType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetUnloadedOrderDetailsVariables {
    taskWaypointId: number;
    pageRequest?: {
        page: number;
        size: number;
    };
    trackingNumber?: string;
    loadingWaypointId?: number;
    overallStatus?: string;
}
